export default __webpack_public_path__ + "5327e7a2f49c83d494b8fbea0fe5941e.png";